// Baked-in sample season for the isolated G-Season sandbox: 3 events, one
// roster, per-event deterministic scores (different seeds → different finishes)
// so the season table has movement. Each event is tournament-shaped so it feeds
// buildReports/rankTeams directly. No randomness, no DB — a stable constant.
const PARS = [4, 5, 3, 4, 4, 3, 5, 4, 4, 4, 3, 5, 4, 4, 3, 4, 5, 4]
const STROKE_INDEX = [7, 3, 15, 1, 11, 17, 5, 9, 13, 8, 18, 2, 10, 6, 16, 12, 4, 14]

const ROSTER = [
  { id: 't1', name: 'Ratliff / Keese', players: ['Mark Ratliff', 'Cole Keese'], ph: [8, 14] },
  { id: 't2', name: 'Reed / Fox',       players: ['Tom Reed', 'Jim Fox'],       ph: [5, 11] },
  { id: 't3', name: 'Lee / Park',       players: ['Ann Lee', 'Sam Park'],       ph: [2, 20] },
  { id: 't4', name: 'Cole / Vega',      players: ['Ben Cole', 'Cara Vega'],     ph: [12, 9] },
  { id: 't5', name: 'Diaz / Nolan',     players: ['Rico Diaz', 'Pat Nolan'],    ph: [16, 18] },
  { id: 't6', name: 'Ford / Shah',      players: ['Gus Ford', 'Amir Shah'],     ph: [10, 7] },
]

// Deterministic per-player round; lower playing handicaps score better on
// average, a seed pattern adds spread so finishes shuffle across events.
function genScores(ph, seed) {
  const out = {}
  for (let h = 0; h < 18; h++) {
    const par = PARS[h]
    const v1 = ((h * 5 + seed * 3) % 5) - 2
    const v2 = ((h * 7 + seed * 2 + 3) % 5) - 2
    const p1 = Math.max(2, par + Math.round((ph[0] || 12) / 9) + v1 - 1)
    const p2 = Math.max(2, par + Math.round((ph[1] || 12) / 9) + v2 - 1)
    out[h + 1] = { p1score: p1, p2score: p2, bestBall: Math.min(p1, p2) }
  }
  return out
}

function makeEvent(id, name, date, seedBase) {
  const teams = {}
  ROSTER.forEach((tm, i) => {
    teams[tm.id] = {
      info: { name: tm.name, players: tm.players, playingHandicaps: tm.ph },
      scores: genScores(tm.ph, seedBase + i),
    }
  })
  return {
    id,
    name,
    date,
    tournament: {
      info: { name, course: 'Pine Bluff Country Club', date, playStyle: 'stroke', pars: PARS, strokeIndex: STROKE_INDEX },
      flights: { field: { info: { name: 'Field' }, teams } },
    },
  }
}

export const SAMPLE_SEASON = {
  name: 'G- Sample Season',
  events: [
    makeEvent('e1', 'Spring Opener', '2026-04-11', 1),
    makeEvent('e2', 'Member-Guest', '2026-06-13', 4),
    makeEvent('e3', 'Fall Classic', '2026-09-19', 9),
  ],
}
